/**
 * Drawer Component Constants
 */

import { TOOLBAR_COLORS } from "components/toolbars/constants";

// Re-export from contexts for consistency
export {
    DRAWER_ANIMATION_DURATION,
    DRAWER_HEIGHT_RATIO,
    DRAWER_RIGHT_MARGIN,
    DRAWER_WIDTH,
} from "contexts/drawers/constants";

// Layout lives in its own leaf module so the pure snap math can be unit tested in Node —
// see the comment there. Re-exported so components have a single constants import.
export { DRAWER_LAYOUT } from "./layout";

// Colors
export const DRAWER_COLORS = {
    /** Drawer background */
    BG: TOOLBAR_COLORS.WHITE,
    /** Header background - white to blend with main window */
    HEADER_BG: TOOLBAR_COLORS.WHITE,
    /** Border color */
    BORDER: TOOLBAR_COLORS.BORDER,
    /** Text color */
    TEXT: TOOLBAR_COLORS.DEFAULT,
    /** Icon color */
    ICON: TOOLBAR_COLORS.DEFAULT,
    /** Button background */
    BUTTON_BG: TOOLBAR_COLORS.HOVER,
    /** Default text */
    DEFAULT: TOOLBAR_COLORS.DEFAULT,
    /** Overlay background */
    OVERLAY_BG: "rgba(0, 0, 0, 0.3)",
} as const;

// Z-index
export const DRAWER_Z_INDEX = 1060;
